import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { MomentModule } from "ngx-moment";

import { ModalModule } from "ngx-bootstrap/modal";
import { PdfViewerModule } from "ng2-pdf-viewer";

import {
  AnnotationIndexComponent,
  AnnotationRouting,
  AnnotationResolve,
} from "./index";

import { SharedModule } from "./../shared/shared.module";

@NgModule({
  imports: [
    CommonModule,
    MomentModule,
    FormsModule,

    SharedModule,

    AnnotationRouting,

    ModalModule.forRoot(),
    PdfViewerModule,
  ],
  declarations: [AnnotationIndexComponent],
  providers: [AnnotationResolve],
})
export class AnnotationModule {}
